export const DEFAULT_ROWS_PER_PAGE = 20;
export const NUM_ROWS_EXPORTED_IN_CSV = 1000;
export const PAGE_SIZE_OPTIONS = [20, 30, 50, 100];